import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonComponentsModule } from '../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/common-components/common-components.module';
import { PipesModule } from '../../../../../../SUVO-CORE-CLIENT-LIB/projects/suvo-core-client-lib/src/lib/features/pipes/pipes.module';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation.component';
import { GeneralPromptSaveDialogComponent } from './general-prompt-save-dialog/general-prompt-save-dialog.component';
import { AngularMaterialModule } from './modules/angular-material/angular-material.module';

const declarations = [GeneralPromptSaveDialogComponent, ConfirmationDialogComponent];

const imports = [
  CommonModule,
  AngularMaterialModule,
  RouterModule,
  FlexLayoutModule,
  FormsModule,
  ReactiveFormsModule,
  PipesModule,
  CommonComponentsModule,
];

@NgModule({
  imports,
  declarations,
  exports: [...declarations, ...imports],
})
export class SharedModule {}
